import { afterNextRender, DestroyRef, Directive, ElementRef, inject, output, Renderer2 } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[dropdownMenuToggle]'
})
export class DropdownMenuToggleDirective {
  public menuToggle = output<boolean>();
  private readonly elementRef = inject<ElementRef<HTMLElement & { shadowRoot: ShadowRoot }>>(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly destroyRef = inject(DestroyRef);
  private unListen: () => void;

  constructor() {
    this.destroyRef.onDestroy(() => {
      if (this.unListen) {
        this.unListen();
      }
    });

    afterNextRender(() => {
      if (this.elementRef) {
        const el = this.elementRef.nativeElement;

        setTimeout(() => {
          const trigger = el.shadowRoot.querySelector('.dropdown-trigger');
          const panel = el.shadowRoot.querySelector('.dropdown-panel');
          this.unListen = this.renderer.listen(trigger, 'click', (event: MouseEvent) => {
            event.stopPropagation();
            if (!panel.classList.contains('visible')) {
              this.menuToggle.emit(true);
            }
          });
        }, 0);
      }
    });
  }
}
